import React from 'react'

import { shallowEqual, useSelector } from 'react-redux'

import { BrandManagerIdentityProviders } from '@enums'
import { IApplicationState } from '@store'
import { selectIsSocialCampaign } from '@store/campaigns'
import { selectIdentityFollowersCount, selectIdentityProvider } from '@store/submissions'
import Theme from '@theme'
import { H5, Icon } from '@tribegroup'
import { abbreviateNumberOrDash } from '@utils'

interface ISubHeaderLabelFollowersProps {
  campaignId: number
  submissionId: number
}

export const SubHeaderLabelFollowers: React.FC<ISubHeaderLabelFollowersProps> = ({
  campaignId,
  submissionId,
}) => {
  const { showSocialProfile, followersCount, provider } = useSelector(
    (state: IApplicationState) => ({
      showSocialProfile: selectIsSocialCampaign(state, campaignId),
      followersCount: selectIdentityFollowersCount(state, submissionId),
      provider: selectIdentityProvider(state, submissionId),
    }),
    shallowEqual,
  )

  const showFollowers = provider != BrandManagerIdentityProviders.Pinterest
  if (showSocialProfile && showFollowers) {
    return (
      <H5 className="follower-count" inline light color={Theme.grey700Color}>
        {abbreviateNumberOrDash(followersCount)}
      </H5>
    )
  }

  if (!showSocialProfile) {
    return <Icon size={0.75} glyph="content-campaign" color={Theme.primaryColor} />
  }

  return <></>
}

export default SubHeaderLabelFollowers
